<ion-list-header>
  <ion-label>{{ title }}</ion-label>

  @if (percentage) {
    <ion-note
      class="percentage"
      [ngClass]="{'danger': percentage > 0}"
    >
      <yu-icon [name]="percentage > 0 ? 'arrow-circle-up' : 'arrow-circle-down'"></yu-icon>
      {{ percentage | percent: '1.2-2' }}
    </ion-note>
  }

  <ion-note>
    {{ cost  | currency: 'EUR' : 'symbol' : '1.2-2' : 'es' }}
  </ion-note>
</ion-list-header>
